<template>
  <b-modal @hide="createModalClose" ref="factoryModal" :title="$t('工場情報登録')" size="xl" hide-footer>
    <b-container>
      <loading :active.sync="create.load" :loader="'dots'" :color="'#FFF'" :background-color="'#000'" :can-cancel="false" :is-full-page="true"></loading>
      <div class="border m-4 p-4 column">
        <div class="my-3 d-flex flex-column align-items-center">
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">
              {{ $t("国") }}
            </label>
            <div class="col-sm-8">
              <select
                v-model="create.form.countryCode"
                class="form-control"
                id="exampleFormControlSelect1"
              >
                <template>
                  <option
                    v-for="(item, index) in country"
                    :key="index"
                    :value="item.code"
                  >{{ $t(item.name) }}</option>
                </template>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">
              {{ $t("工場名") }}
              <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
            </label>
            <div class="col-sm-8">
              <input v-model="create.form.name" type="text" class="form-control" placeholder="ものレボ株式会社" />
            </div>
          </div>
          <div v-if="create.form.countryCode == 'JP'" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("カナ") }}</label>
            <div class="col-sm-8">
              <input v-model="create.form.kana" type="text" class="form-control" placeholder="モノレボカブシキガイシャ" />
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">
              {{ $t("工場コード") }}
            </label>
            <div class="col-sm-8">
              <input v-model="create.form.code" type="text" class="form-control" />
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">
              {{ $t("郵便番号") }}
            </label>
            <div class="col-sm-8">
              <input
                v-model="create.form.zipcode"
                type="text"
                class="form-control"
                placeholder="604-8206"
              />
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">
              {{ create.form.countryCode === 'JP' ? $t("都道府県") : $t("州") }}
            </label>
            <div class="col-sm-8">
              <select
                v-model="create.form.prefCode"
                class="form-control"
                id="exampleFormControlSelect1"
              >
                <option value></option>
                <template v-if="create.form.countryCode">
                  <option
                    v-for="(item, index) in pref[create.form.countryCode]"
                    :key="index"
                    :value="item.code"
                  >{{ $t(item.name) }}</option>
                </template>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">
              {{ $t("住所1") }}
            </label>
            <div class="col-sm-8">
              <input
                v-model="create.form.address1"
                type="text"
                class="form-control"
                placeholder="京都市中京区"
              />
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">
              {{ $t("住所2") }}
            </label>
            <div class="col-sm-8">
              <input
                v-model="create.form.address2"
                type="text"
                class="form-control"
                placeholder="新町通三条上ル町頭町112"
              />
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("住所3") }}</label>
            <div class="col-sm-8">
              <input v-model="create.form.address3" type="text" class="form-control" placeholder="菊三ビル3F" />
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">
              {{ $t("TEL") }}
            </label>
            <div class="col-sm-8">
              <input v-model="create.form.phoneNo" type="text" class="form-control" placeholder="075-585-5097" />
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("FAX") }}</label>
            <div class="col-sm-8">
              <input v-model="create.form.faxNo" type="text" class="form-control" placeholder="075-585-5097" />
            </div>
          </div>


          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("作業指示書管理番号") }}</label>
            <div class="col-sm-8">
              <input v-model="create.form.isoDocNo" type="text" class="form-control" placeholder="" />
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("定時開始時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" id="regular_end_time" data-widget="timepicker">
                <date-picker v-model="create.form.regularStartTime" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("定時終了時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" id="regular_end_time" data-widget="timepicker">
                <date-picker v-model="create.form.regularEndTime" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("稼働開始時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group">
                <date-picker v-model="create.form.displayStartTime" :config="timepicker.options" :disabled="create.form.isFullWorkTime"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("稼働終了時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" id="regular_end_time" data-widget="timepicker">
                <date-picker v-model="create.form.displayEndTime" :config="timepicker.options" :disabled="create.form.isFullWorkTime"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label"></label>
            <div class="col-sm-8">
              <q-toggle
                v-model="create.form.isFullWorkTime"
                :label="$t('24時間稼動')"
              />
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" id="regular_end_time" data-widget="timepicker">
                <date-picker v-model="create.form.breakStartTime1" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" id="regular_end_time" data-widget="timepicker">
                <date-picker v-model="create.form.breakEndTime1" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("シフトの有無") }}</label>
            <div class="col-sm-8">
              <q-toggle
                v-model="create.form.isUseShifts"
                :label="$t('シフト 有')"
              />
            </div>
          </div>

          <div v-show="create.form.isUseShifts" class="form-group row" style="border-bottom:1px solid #ccc">
            <label for="" class="col-sm-4 col-form-label" style="font-weight:bold">{{ $t("シフト1") }}</label>
          </div>

          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("定時開始時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime1.regularStartTime" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("定時終了時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime1.regularEndTime" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("稼働開始時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime1.displayStartTime" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("稼働終了時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime1.displayEndTime" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻①") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime1.breakStartTime1" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻①") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime1.breakEndTime1" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻②") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime1.breakStartTime2" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻②") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime1.breakEndTime2" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div v-show="create.form.isUseShifts" class="form-group row" style="border-bottom:1px solid #ccc">
            <label for="" class="col-sm-4 col-form-label" style="font-weight:bold">{{ $t("シフト2") }}</label>
          </div>

          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("定時開始時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime2.regularStartTime" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("定時終了時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime2.regularEndTime" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("稼働開始時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime2.displayStartTime" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("稼働終了時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime2.displayEndTime" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻①") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime2.breakStartTime1" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻①") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime2.breakEndTime1" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻②") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime2.breakStartTime2" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻②") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime2.breakEndTime2" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div v-show="create.form.isUseShifts" class="form-group row" style="border-bottom:1px solid #ccc">
            <label for="" class="col-sm-4 col-form-label" style="font-weight:bold">{{ $t("シフト3") }}</label>
          </div>

          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("定時開始時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime3.regularStartTime" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("定時終了時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime3.regularEndTime" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("稼働開始時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime3.displayStartTime" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("稼働終了時刻") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime3.displayEndTime" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻①") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime3.breakStartTime1" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻①") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime3.breakEndTime1" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("休憩開始時刻②") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime3.breakStartTime2" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-show="create.form.isUseShifts" class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("休憩終了時刻②") }}</label>
            <div class="col-sm-8">
              <div class="input-group" data-widget="timepicker">
                <date-picker v-model="create.form.workTime3.breakEndTime2" :config="timepicker.options"></date-picker>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <font-awesome-icon :icon="['far', 'clock']" />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label for="" class="col-sm-4 col-form-label">{{ $t("工場カレンダー") }}</label>
            <div class="col-sm-8">
              <div class="row q-with-b">
                <div>
                  <q-toggle
                    v-model="create.isUseFactoryCalendar"
                    :label="$t('工場カレンダーを設定')"
                  />
                </div>
                <div class="q-ml-sm" style="line-height: 3;">
                  <q-icon name="help">
                    <q-tooltip anchor="top right" self="top left">
                      {{ $t('設定されない場合、会社カレンダーが適用されます。') }}
                    </q-tooltip>
                  </q-icon>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row justify-content-end" v-if="create.isUseFactoryCalendar">
            <div class="col-sm-8">
              <button class="btn-content btn-light flex-shrink-1" @click="openFactoryCalendarModal">{{ $t("設定") }}</button>
            </div>
          </div>
          <div class="form-group row" v-if="create.isUseFactoryCalendar">
            <label class="col-sm-4 col-form-label">
              <span class="ml-5">{{ $t("カレンダー表示先頭月") }}</span>
            </label>
            <div class="col-sm-8">
              <b-form-select
                class="form-control"
                v-model="create.form.options.calendarDisplayMonth"
                :options="this.$appConfig.CalendarDisplayMonth"
                value-field="value"
                text-field="name"
              ></b-form-select>
            </div>
          </div>
          <div class="form-group row" v-if="create.isUseFactoryCalendar">
            <label class="col-sm-4 col-form-label">
              <span class="ml-5">{{ $t("週の始まり") }}</span>
            </label>
            <div class="col-sm-8">
              <b-form-select
                class="form-control"
                v-model="create.form.options.calendarDisplayDayOfWeek"
                :options="this.$appConfig.CalendarDisplayDayOfWeek"
                value-field="value"
                text-field="name"
              ></b-form-select>
            </div>
          </div>
        </div>
      </div>
    </b-container>

    <div class="modal-footer flex-column">
      <p class="text-danger text-center" v-if="create.error">{{ create.error }}</p>
      <div class="d-flex justify-content-start align-items-start mt-4 mb-4">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          @click="createRegister()"
          :disabled="create.registration"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="create.registration"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t("登録") }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          @click="createModalClose()"
          v-if="!create.confirm"
          :disabled="create.registration"
        >{{ $t("キャンセル") }}</button>
      </div>
    </div>

    <company-calendar-modal
      ref="factoryCalendarModal"
      :title="$t('工場カレンダー登録')"
      :holidays="create.form.holidays"
      @register="registerFactoryCalendarModal"
      :displayMonth="create.form.options.calendarDisplayMonth"
      :displayDayOfWeek="create.form.options.calendarDisplayDayOfWeek"
      :countryCode="create.form.countryCode"
    ></company-calendar-modal>
  </b-modal>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import country from '../../assets/json/country.json'
import pref from '../../assets/json/pref.json'
import CompanyCalendarModal from '../../components/CompanyCalendarModal.vue'
import config from '../../config'

const defaultWorkTime = {
  regularStartTime: '',
  regularEndTime: '',
  displayStartTime: '',
  displayEndTime: '',
  breakStartTime1: '',
  breakEndTime1: '',
  breakStartTime2: '',
  breakEndTime2: '',
}

const defaultCalendarOptions = {
  calendarDisplayMonth: config.CalendarDisplayMonth[config.CalendarDisplayMonthDefaultIndex].value,
  calendarDisplayDayOfWeek: config.CalendarDisplayDayOfWeek[config.CalendarDisplayDayOfWeekDefaultIndex].value,
}
const defaultOptions = Object.assign(defaultCalendarOptions, {})

const defaultForm = {
  code: '',
  name: '',
  key: 'site',
  countryCode: null, // 国
  kana: '', // カナ
  zipcode: '', // 郵便番号
  prefCode: '', // 都道府県
  address1: '', // 住所1
  address2: '', // 住所2
  address3: '', // 住所3
  phoneNo: '', // 電話番号
  faxNo: '', // FAX番号
  isoDocNo: '', // 作業指示書番号
  isFullWorkTime: false,
  regularStartTime: '', // 定時開始時刻
  regularEndTime: '', // 定時終了時刻
  displayStartTime: '', // 稼働開始時刻
  displayEndTime: '', // 稼働終了時刻
  breakStartTime1: '', // 休憩開始時刻
  breakEndTime1: '', // 休憩終了時刻
  breakStartTime2: '', // 休憩開始時刻
  breakEndTime2: '', // 休憩終了時刻
  isUseShifts: false, // シフト有無
  workTime1: _.cloneDeep(defaultWorkTime),
  workTime2: _.cloneDeep(defaultWorkTime),
  workTime3: _.cloneDeep(defaultWorkTime),
  options: _.cloneDeep(defaultOptions),
  holidays: null,
}


export default {
  components: {
    CompanyCalendarModal,
  },
  data() {
    return {
      country: country,
      pref: pref,
      create: {
        load: false,
        form: _.cloneDeep(defaultForm),
        registration: false,
        error: '',
        isUseFactoryCalendar: false,
      },
      isUseInventory: false,
      isUseSmallLot: false,
      isUsePurchase: false,
      master: {},
      originalForm: {},
    }
  },
  methods: {
    async createModalOpen(item = {}) {
      try {
        this.master = {}
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/masters`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
        })
        this.master = res.data
        this.isUseInventory = this.master.company.isUseInventory
        this.isUseSmallLot = this.master.company.isUseSmallLot
        this.isUsePurchase = this.master.company.isUsePurchase
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }

      const copy = this.mixin_deepcopy(item)
      if (copy.id) {
        if (_.isEmpty(copy.workTime1)) {
          copy.workTime1 = _.cloneDeep(defaultWorkTime)
        }
        if (_.isEmpty(copy.workTime2)) {
          copy.workTime2 = _.cloneDeep(defaultWorkTime)
        }
        if (_.isEmpty(copy.workTime3)) {
          copy.workTime3 = _.cloneDeep(defaultWorkTime)
        }
        if (copy.options === null) {
          copy.options = _.cloneDeep(defaultOptions)
        } else {
          Object.keys(defaultOptions).forEach(key => {
            if (!copy.options.hasOwnProperty(key)) {
              copy.options[key] = _.cloneDeep(defaultOptions[key])
            }
          })
        }
        delete copy.companyId
        this.create.form = copy
        this.originalForm = _.cloneDeep(copy)
      } else {
        this.create.form.countryCode = this.$store.getters['auth/userdata'].countryCode
        const company = this.master.company
        this.create.form.displayStartTime = company.displayStartTime
        this.create.form.displayEndTime = company.displayEndTime
        this.create.form.isFullWorkTime = company.isFullWorkTime
        if (!_.isEmpty(company.workTime1)) this.create.form.workTime1 = company.workTime1
        if (!_.isEmpty(company.workTime2)) this.create.form.workTime2 = company.workTime2
        if (!_.isEmpty(company.workTime3)) this.create.form.workTime3 = company.workTime3
        this.create.form.options = _.cloneDeep(defaultOptions)
        this.create.form.regularStartTime = company.regularStartTime
        this.create.form.regularEndTime = company.regularEndTime
        this.create.form.breakStartTime1 = company.breakStartTime1
        this.create.form.breakEndTime1 = company.breakEndTime1
        this.create.form.breakStartTime2 = company.breakStartTime2
        this.create.form.breakEndTime2 = company.breakEndTime2
        this.create.form.isUseShifts = company.isUseShifts
      }
      this.create.isUseFactoryCalendar = this.create.form.holidays !== null

      this.$refs.factoryModal.show()
    },
    createModalClose() {
      this.$refs.factoryModal.hide()
      this.$emit('modal-close')
    },
    getCleanParams(data) {
      return Object.keys(data).reduce((params, key) => {
        if (key === 'parentId') return params
        switch (key) {
          case 'parentId':
            // Do nothing
            break
          case 'workTime1':
          case 'workTime2':
          case 'workTime3':
            params[key] = {
              breakEndTime1: data[key].breakEndTime1 || '',
              breakEndTime2: data[key].breakEndTime2 || '',
              breakStartTime1: data[key].breakStartTime1 || '',
              breakStartTime2: data[key].breakStartTime2 || '',
              displayEndTime: data[key].displayEndTime || '',
              displayStartTime: data[key].displayStartTime || '',
              regularStartTime: data[key].regularStartTime || '',
              regularEndTime: data[key].regularEndTime || '',
            }
            break
          case 'isFullWorkTime':
          case 'isUseShifts':
            params[key] = data[key]
            break
          case 'options':
          case 'holidays':
            if (data[key] !== null) params[key] = data[key]
            break
          default:
            params[key] = data[key] ? data[key] : ''
            break
        }
        return params
      }, {})
    },
    _createRegister(data) {
      return this.$axios({
        method: data.id ? 'put' : 'post',
        headers: {
          Authorization: this.authorization ? this.authorization : null,
        },
        url: `${this.$appConfig.CommonApiUrl}/space`,
        data: this.getCleanParams(data),
      })
    },
    async createRegister() {
      const pwd = this.create.form
      if (!pwd.name) {
        this.create.error = this.$t('工場名') + this.$t('必須メッセージ')
        return
      }
      this.create.error = ''
      this.create.registration = true

      try {
        await this._createRegister(this.create.form)

        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.create = {
          load: false,
          form: _.cloneDeep(defaultForm),
          registration: false,
          error: '',
          isUseFactoryCalendar: false,
        }
        this.$refs.factoryModal.hide()
        this.$emit('registed')
      } catch (err) {
        console.log(err)
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }
      this.create.registration = false
    },
    openFactoryCalendarModal() {
      this.$refs.factoryCalendarModal.openModal()
    },
    async registerFactoryCalendarModal(holidays) {
      this.create.load = true

      try {
        // 工場が登録済みの場合のみ休日情報の更新を行う
        if (this.originalForm.id) {
          const data = _.cloneDeep(this.originalForm)
          data.holidays = holidays

          await this._createRegister(data)

          this.$toasted.success(this.$t('データ登録完了メッセージ'))
        }

        this.create.form.holidays = holidays
        this.$refs.factoryCalendarModal.closeModal()
      } catch (e) {
        console.log(e)
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }

      this.create.load = false
    },
  },
  watch: {
    'create.form.zipcode': function(zip) {
      let _this = this.create.form
      if (_this.countryCode != 'JP') return

      try {
        // NOTE: html上で直接scriptを呼び出している
        // eslint-disable-next-line no-undef
        new YubinBango.Core(zip, function(addr) {
          _this.prefCode = addr.region_id ? 'JP-' + (addr.region_id < 10 ? '0' + addr.region_id : addr.region_id) : '' // 都道府県ID
          _this.address1 = addr.locality // 市区町村
          _this.address2 = addr.street // 町域
        })
      } catch (err) {
        // console.log(err)
      }
    },
    'create.form.isFullWorkTime': function(boolean) {
      if (boolean) {
        this.create.form.displayStartTime = '00:00'
        this.create.form.displayEndTime = '23:59'
      }
    },
    'create.isUseFactoryCalendar': function(newValue) {
      if (newValue && this.create.form.holidays === null && this.master && this.master.company) {
        // 会社カレンダーが設定済みであればその値を利用する
        const company = this.master.company
        this.create.form.holidays = company.holidays
        if (company.options) {
          Object.keys(defaultCalendarOptions).forEach(key => {
            if (company.options.hasOwnProperty(key)) {
              this.create.form.options[key] = company.options[key]
            }
          })
        }
      }
      if (!newValue) {
        this.create.form.holidays = null
      }
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>
